import Spacing from '@components/atoms/Spacing';
import { LightParagraph } from '@components/atoms/Typography';
import BotExplanation from '@components/molecules/BotExplanation';
import RadioGroup from '@components/molecules/RadioGroup';
import { UserIntent } from '@graphql/generated';
import { QuoteInitialForm, ZeroKMFormResult } from '@lib/data/typesQuestions';
import GridBox from 'components/atoms/GridBox';
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';

interface Props {
  onSubmit: (data: ZeroKMFormResult) => void;
  item: QuoteInitialForm;
}

const ZeroKMForm: FC<Props> = ({ onSubmit, item }) => {
  const { register, handleSubmit, errors } = useForm<{
    zeroKM: 'no' | 'yes';
  }>();

  return (
    <form
      onSubmit={handleSubmit((data) => {
        if (item.vehicle)
          onSubmit({
            vehicle: {
              ...item.vehicle,
              zeroKm: data.zeroKM === 'yes',
            },
          });
      })}
    >
      <GridBox justifyContent="center">
        <Spacing bottom={3}>
          <LightParagraph fontSize={14} center>
            É considerado 0km veículos com menos de <strong>30 dias</strong> da
            saída da concessionária.
          </LightParagraph>
        </Spacing>
        <GridBox width={[1, 0.5, 0.5]}>
          <RadioGroup
            inputRef={register({ required: 'Escolha uma das opções' })}
            name="zeroKM"
            errorMessage={errors.zeroKM?.message}
            onSelected={(value) => {
              if (item.vehicle)
                onSubmit({
                  vehicle: { ...item.vehicle, zeroKm: value === 'yes' },
                });
            }}
            options={[
              {
                label: 'Não',
                checked: item.vehicle?.zeroKm !== null && !item.vehicle?.zeroKm,
                value: 'no',
              },
              {
                label: 'Sim',
                value: 'yes',
                checked: !!item.vehicle?.zeroKm,
              },
            ]}
          />
        </GridBox>
      </GridBox>
      <BotExplanation>
        {item.userIntent === UserIntent.SuhaiPartner
          ? 'Em caso de Sinistro será solicitado a Nota Fiscal com a Data de Saída do veiculo da concessionária'
          : 'Caso seja 0km será necessário enviar a nota fiscal para finalizar a contratação do seguro.'}
      </BotExplanation>
    </form>
  );
};

export default ZeroKMForm;
